import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    GetBlockPluckingReportData,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPointID,
    GetSubFeildsByFieldID,
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(estateID, registrationNumber) {
    const response = await CommonGet('/api/EmployeeTask/GetTaskDetailByOperationEntityID', 'operationEntityID=' + estateID + '&registrationNumber=' + registrationNumber);
    return response.data;
}

async function GetFieldsByCollectionPointID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["fieldName"]
        }
    }
    return divisionArray;
}

async function GetSubFeildsByFieldID(id) {
    var subFieldArray = [];
    const response = await CommonGet('/api/Field/GetSubFeildsByFieldID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            subFieldArray[item[1]["subFieldID"]] = item[1]["subFieldName"]
        }
    }
    return subFieldArray;
}

async function GetBlockPluckingReportData(data) {
    console.log('data',data)
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        searchDate: data.searchDate,
        registrationNumber: data.registrationNumber,
        fieldID: parseInt(data.fieldID),
        subFieldID: parseInt(data.subFieldID),
    };
    const response = await CommonPost('/api/BlockPluckingReport/GetBlockPluckingReportData', null, model);
    return response.data;
}